<section class="start-window">
	<div class="hero-section">
		<div class="hero-image">
			<div class="video-cta-base">
				<button type="button" class="btn-action btn-action-primary btn-video" (click)="openVideoModal()">
					Ver video instructivo
					<i class="fa fa-play-circle" aria-hidden="true"></i>
				</button>
			</div>
		</div>

		<div class="hero-content">
			<div class="hero-kicker">
				<span></span>
				Identificar &bull; Conectar &bull; Reconocer &bull; Visibilizar  &bull; Replicar
			</div>

			<h1>Concurso Pr&aacute;cticas Ejemplares Ecuador</h1>

			<p class="hero-description">
				Si eres un funcionario p&uacute;blico y lideras un proyecto que está transformando la gestión p&uacute;blica, es momento de visibilizarlo, postula aqu&iacute;.
			</p>

			<div class="hero-actions">
				<button type="button" class="btn-action btn-action-primary" (click)="redirectTo('login')">
					<i class="fa fa-user-o" aria-hidden="true"></i>
					Ingresar
				</button>

				<button type="button" class="btn-action btn-action-outline" (click)="redirectTo('registro')">
					Crear cuenta
				</button>
			</div>

			<!-- <div class="trust-note">
				<i class="fa fa-shield" aria-hidden="true"></i>
				<span>Un espacio colaborativo y confiable para promover la innovaci&oacute;n p&uacute;blica en Ecuador.</span>
			</div> -->
		</div>
	</div>

</section>

<div class="video-modal-backdrop" *ngIf="showVideoModal" (click)="closeVideoModal()">
	<div class="video-modal" role="dialog" aria-modal="true" aria-label="Video instructivo" (click)="$event.stopPropagation()">
		<button type="button" class="video-modal-close" aria-label="Cerrar video" (click)="closeVideoModal()">
			<i class="fa fa-times" aria-hidden="true"></i>
		</button>

		<div class="video-frame">
			<iframe
				src="https://www.youtube.com/embed/7j3SlgHLoSg?autoplay=1&rel=0"
				title="Video instructivo"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen>
			</iframe>
		</div>
	</div>
</div>
